import { forwardRef } from "react";
import { Link, LinkProps } from "react-router";

export type RouterLinkProps = Omit<LinkProps, "to"> & {
  href: string;
};

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  function RouterLink({ href, ...other }, ref) {
    return <Link ref={ref} to={href} {...other} />;
  },
);
